export interface ComparatorOptions {
  orderBy?: "ASC" | "DESC";
  nulls?: "FIRST" | "LAST";
}

export const DEFAULT_COMPARATOR_OPTIONS: ComparatorOptions = {
  orderBy: "DESC",
  nulls: "LAST",
};
